(() => {
  if (customElements.get('product-recommendation')) return;
  const pages = new Map();
  const loadHome = (path) => {
    if (!pages.has(path)) {
      const url = new URL(path, location.origin);
      url.searchParams.set('p3d_recommendations', '1');
      pages.set(path, fetch(url, { credentials: 'same-origin', cache: 'no-cache', signal: AbortSignal.timeout(10000) })
        .then(response => {
          if (!response.ok) throw new Error('Recommendation source unavailable');
          return response.text();
        })
        .then(html => new DOMParser().parseFromString(html, 'text/html')));
    }
    return pages.get(path);
  };
  class ProductRecommendation extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.auto !== 'true' || this.dataset.syncState) return;
      this.dataset.syncState = 'loading';
      const handle = this.dataset.productHandle;
      const navigation = [...document.querySelectorAll('.p3d-floating-menu__product[data-product-handle]')]
        .find(card => card.dataset.productHandle === handle);
      const initial = navigation?.querySelector('.p3d-floating-menu__badge')?.textContent.trim();
      if (!this.textContent.trim() && initial) this.show(initial);
      try {
        const home = await loadHome(this.dataset.homeUrl);
        if (!this.isConnected) return;
        const card = [...home.querySelectorAll('[data-home-card-id][data-product-handle]')]
          .find(card => card.dataset.productHandle === handle);
        if (card) {
          const badge = card.querySelector('[data-products-badge]');
          const series = card.closest('[data-products-series]');
          const own = badge?.dataset.ownBadge || '';
          const text = own || series?.dataset.defaultBadge || badge?.dataset.fallbackBadge || '';
          const visible = badge && badge.dataset.hideBadge !== 'true' && text && (own || series?.dataset.showBadge === 'true');
          this.show(visible ? text : '');
        }
        this.dataset.syncState = 'ready';
      } catch {
        this.dataset.syncState = 'unavailable';
      }
    }
    show(text) {
      this.textContent = text;
      this.hidden = !text;
    }
  }
  customElements.define('product-recommendation', ProductRecommendation);
})();
